import {LogicCondition} from "./logic-condition";
import {LogicGroupType} from "./logic-group-type";

export class LogicGroup {
  public type: LogicGroupType = LogicGroupType.OR;
  public items: LogicCondition[] = [];
}
